const SvgAnalytics1 = (props) => (
  <>
    <defs />
    <path
      d="m48 294.62-.1 88.6M143.96 231.02l.08 151.74M239.86 176.71V382.3M336 118.82v263.67M0 0v383.97l384 .03"
      stroke="#042068"
      strokeWidth="3px"
      fill="none"
      strokeMiterlimit={10}
    />
    <circle cx={239.83} cy={176.13} r={8} fill="#1e62f5" strokeWidth={0} />
    <circle cx={240} cy={176} r={24} stroke="#021d6c" fill="none" strokeMiterlimit={10} />
    <circle cx={48} cy={288} r={8} stroke="#042068" strokeWidth="3px" fill="none" strokeMiterlimit={10} />
    <circle cx={336} cy={111.99} r={8} stroke="#042068" strokeWidth="3px" fill="none" strokeMiterlimit={10} />
    <circle cx={144} cy={224} r={8} stroke="#042068" strokeWidth="3px" fill="none" strokeMiterlimit={10} />
  </>
);

export default SvgAnalytics1;
